import { updateChannels } from '@/mocks/home';

export default function UpdateChannels() {
  return (
    <section id="channels" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="overflow-hidden rounded-lg border border-primary-200 bg-primary-50/70 p-6 md:p-10">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
            <div className="lg:col-span-5">
              <span className="text-xs font-medium tracking-[0.2em] text-primary-600">保持畅通</span>
              <h2 className="mt-3 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-4xl">
                下次换地址，第一时间知道
              </h2>
              <p className="mt-4 text-base leading-relaxed text-foreground-700">
                地址调整无法完全避免，但只要记住本页，就不会再因为打不开而错过最新内容。以下方式任选其一即可。
              </p>
              <a
                href="#addresses"
                className="mt-7 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-primary-600"
              >
                <i className="ri-bookmark-line text-base"></i>
                收藏并查看当前地址
              </a>
            </div>

            <div className="lg:col-span-7">
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-1 lg:gap-5">
                {updateChannels.map((item) => (
                  <div
                    key={item.title}
                    className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5"
                  >
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                      <i className={`${item.icon} text-xl`}></i>
                    </span>
                    <div className="flex-1">
                      <h3 className="font-heading text-base font-bold text-foreground-950">
                        {item.title}
                      </h3>
                      <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                    </div>
                    <button
                      type="button"
                      className="mt-1 hidden cursor-pointer items-center gap-1 whitespace-nowrap text-xs font-medium text-primary-600 transition-colors duration-200 hover:text-primary-700 sm:flex"
                    >
                      {item.action}
                      <i className="ri-arrow-right-s-line"></i>
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}